import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const styles: moduleStyleType = {
    root: {
        minWidth: 500,
    },
}
